import styles from './Left.module.scss';

import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';
import { Card } from '@work4all/components/lib/dataDisplay/card';
import { LabeledInputWithTextBuildingBlock } from '@work4all/components/lib/input/labeled-input-with-text-building-block/LabeledInputWithTextBuildingBlock';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { ControllerPlus } from '../../../../../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../../../../../form-plus/use-form-context-plus';
import { LabeledInput } from '../../../../../../../../locked-inputs';
import { Panel } from '../../../../../../../../mask-overlay/components/panel/Panel';
import { ControlWrapper } from '../../../../../../../components/control-wrapper';
import { useMaskContext } from '../../../../../../../hooks/mask-context';
import { CrmMaskFormValue } from '../../../../../types';

const collapseClasses = {
  root: styles.collapseContainer,
  wrapperInner: styles.collapseWrapperInner,
};

const ENTITIES_WITH_TEXT_BUILDING_BLOCK = [Entities.note, Entities.callMemo];

export const Left = () => {
  const { t } = useTranslation();

  const mask = useMaskContext();

  const { register, control } = useFormContextPlus<CrmMaskFormValue>();

  return (
    <Panel className={styles.common}>
      <Collapse
        classes={collapseClasses}
        title={t(`COMMON.${mask.entity.toUpperCase()}`)}
        className={styles.collapse}
        defaultOpen={true}
        bottomIndent="lg"
      >
        <Card sx={{ display: 'grid', gridAutoRows: 'auto 1fr' }}>
          <ControlWrapper>
            <LabeledInput
              {...register('title')}
              label={t('INPUTS.DESCRIPTION')}
            />
          </ControlWrapper>
          <ControllerPlus
            control={control}
            name="note"
            render={({ field }) => {
              return (
                <LabeledInputWithTextBuildingBlock
                  {...field}
                  label={t('INPUTS.NOTE')}
                  multiline={true}
                  showTextBuildingBlockAction={ENTITIES_WITH_TEXT_BUILDING_BLOCK.includes(
                    mask.entity
                  )}
                />
              );
            }}
          />
        </Card>
      </Collapse>
    </Panel>
  );
};
